import { createAction } from 'typesafe-actions';

import { ViewParams } from 'shared/types/view-params';

export const saveExternalConfig = createAction('config/SAVE_EXTERNAL_CONFIG')<Partial<ViewParams>>();
